import styled from 'styled-components'

export const Loader = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100svh;
  width: 100%;
  max-width: 100%;
`
